<template>
  <div class="table">
    <no-data v-if="!contractListData.length"> </no-data>
    <template v-else>
      <div class="contract-item" v-for="item in list" :key="item.id">
        <div @click="getContractDetails(item)" class="item-msg">
          <div style="width: 180px">
            <h1 class="contract-number">{{ item.contractCode }}</h1>

            <div style="width: 160px" class="label-card">
              <a-tag v-if="item.isArchive == 'Y'" color="green"> 已归档 </a-tag>
              <a-tag v-if="item.isArchive == 'N' && item.isSettlement == 'Y'" color="red"> 待归档 </a-tag>
              <!-- <a-tag v-if="item.isAllot === 'Y'" color="green"> 已分配 </a-tag>
            <a-tag v-if="item.isAllot === 'N'" color="orange"> 待分配 </a-tag> -->
              <a-tag v-if="item.isDelivery != 'Y' && item.auditStatus == '已审核'" color="orange"> 待交件 </a-tag>
              <a-tag v-if="item.isDelivery == 'Y' && item.isSettlement != 'Y'" color="orange"> 已交件 </a-tag>
              <a-tag v-if="item.isDelivery == 'Y' && item.isSettlement != 'Y'" color="orange"> 待结佣 </a-tag>
              <a-tag v-if="item.isArchive != 'Y' && item.isSettlement == 'Y'" color="orange"> 已结佣 </a-tag>
              <a-tag v-if="item.auditStatus === '3' && item.isDelivery === 'N'" color="green">已审核 </a-tag>
              <a-tag v-if="item.auditStatus == '4'" color="orange">驳回 </a-tag>
              <a-tag v-if="item.auditStatus =='1' || item.auditStatus == '待审核'" color="orange">待审核 </a-tag>
              <a-tag v-if="item.auditStatus =='2'" color="orange">审核中 </a-tag>
            </div>
          </div>
          <div style="width: 50px">
            <a-tag color="green"> {{ item.contractType === '2' ? '售' : '租' }} </a-tag>
            <!-- <div style="width: 100px"> {{ item.contractType==='2'?'售房合同':'租房合同' }}</div> -->
          </div>
          <!-- 房源信息 -->
          <a-col :span="3" style="marginright: 40px">
            <h1>{{ item.houseCode }}</h1>
            <!-- <p>{{ item.shopName }}</p> -->
            <p>
              {{ item.houseStreet || '' }} <span v-if="item.houseNumber">{{ item.houseNumber }}号</span>
              <span v-if="item.houseNumberDeputy">附{{ item.houseNumberDeputy }}号</span>
            </p>
          </a-col>
          <!-- 客源信息 -->
          <div style="width: 200px" v-if="tabKey != '4' && tabKey != '7'">
            <h1>{{ item.lesseeCode }}</h1>
            <p>{{ item.lesseeName }}</p>
          </div>
          <a-col :span="2" style="paddingleft: 20px">
            <p>房源面积：</p>
            <p>
              {{ item.grossFloorArea }}
            </p>
          </a-col>

          <a-col :span="3" v-if="tabKey == '4' || tabKey == '7'">
            <p>交件时间：</p>
            <p>{{ item.deliveryTime }}</p>
          </a-col>
          <a-col :span="3" v-if="tabKey == '4' || tabKey == '7'">
            <p>结佣时间：</p>
            <p>{{ item.settlementTime }}</p>
          </a-col>
          <!-- <div style="width: 200px">
          
        </div> -->
          <a-col :span="3" v-if="tabKey == '4'">
            <p>归档时间：</p>
            <p>{{ item.archiveTime }}</p>
          </a-col>

          <a-col :span="3">
            <p>未收金额：{{ formatPrice(item.receivableAmount - item.realityAmount) }}</p>
            <p>成交金额：{{ item.rentExpense }}</p>
          </a-col>

          <!-- <div style="width: 120px">
              <p style="width: 120px">房佣{{ item.lessorComm }}</p>
              <p style="width: 120px">客佣{{ item.lesseeComm }}</p>
            </div> -->
          <div style="width: 120px">
            <p style="width: 120px">结单业绩：{{ getMoney(item) }}</p>
            <p style="width: 120px">实收：{{ item.realityAmount || 0 }}</p>
          </div>
          <div style="width: 130px">
            <h1>{{ item.signName }}</h1>
            <p style="width: 130px">{{ item.signDate }}签约</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    contractListData: {
      type: Array,
      required: true,
    },
    // tab的选择项
    tabKey: {
      type: [Number, String],
      default: '',
    },
  },
  watch: {
    contractListData: {
      handler() {
        console.log(this.contractListData, 'constant')
        this.list = [...this.contractListData]
      },
      deep: true,
      immediate: true,
    },
    tabKey: {
      handler() {},
      immediate: true,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  methods: {
    getContractDetails(item) {
      this.$router.push({
        path: '/contract/details',
        query: { id: item.id },
      })
      // this.$router.push('/contract/details')
      console.log(item)
    },
    formatPrice(val) {
      if ((val + '').indexOf('.') >= 0) {
        return val.toFixed(2)
      }
      return val + '.00'
    },
    // 获取结单业绩
    getMoney(item) {
      let value =
        (Number(item.lesseeComm) || 0) +
        (Number(item.lessorComm) || 0) -
        ((Number(item.restInfoFee) || 0) + (Number(item.houstInfoFee) || 0) + (Number(item.customerInfoFee) || 0))-(Number(item.amountOfRedPunch) || 0)
      if(value < 0){
        value = 0
      }

      return this.formatPrice(value)
    },
  },
}
</script>
<style lang="less" scoped>
.table {
  overflow: hidden;
  overflow-x: auto;
}
.contract-item {
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(238, 236, 236);
  padding-top: 10px;
  // border:1px solid transparent;
  &:hover {
    background: #f0f5ff;
  }
  .item-msg {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: 100%;
    // padding-right: 80px;
    > div {
      // width: 100px;
      margin-right: 20px;
      // border-right: 0.5px solid rgba(0,0,0,.16);
      .contract-number {
        font-size: 14px;
        font-weight: 700;
        color: #222222;
      }
      h1 {
        font-size: 14px;
        font-weight: 600;
        color: #000;
      }
      p {
        font-size: 14px;
      }
    }
  }
  .item-btn {
    margin-right: 80px;
    button {
      background-color: #a4adb3;
      color: #fff;
      border-radius: 15px;
      font-size: 14px;
    }
  }
  .reject {
    background-color: #a4adb3;
    color: #fff;
    border-radius: 6px;
    margin-right: 10px;
  }
}
</style>
